import { TFunction } from 'react-i18next';

const mappingOrderDirection = (t: TFunction, orderDirection?: number) => {
  if (orderDirection === 1) {
    return 'O';
  } else if (orderDirection === 2) {
    return 'I';
  }
};

export { mappingOrderDirection };
